module.exports = __webpack_public_path__ + "static/agency-a8f7989777e97eb7f13ba2290c518e22.svg";